import {
    formatNationalIdentityNumber,
    getAgeInYearsAndMonths,
} from '@/caregiverSpace/shared/lib';
import { ICaregiverConsultationDto } from '@/caregiverSpace/shared/model';
import { CopyableField } from '@/caregiverSpace/shared/ui';

type NationalIdentifierTableColumnProps = {
    row: ICaregiverConsultationDto;
};

export const NationalIdentifierTableColumn = ({
    row,
}: NationalIdentifierTableColumnProps) => {
    const ageInfo = getAgeInYearsAndMonths(row.Patient.BirthDate);
    const nationalIdentifier = formatNationalIdentityNumber(
        row.Patient.CprNumber,
    );

    return (
        <CopyableField
            fieldType="nationalIdentifier"
            displayValue={
                <span>
                    {nationalIdentifier} ({ageInfo})
                </span>
            }
            copyValue={row.Patient.CprNumber}
            className="font-normal"
        />
    );
};
